module.exports = __webpack_public_path__ + "static/boulevard-deb0f434e083fd935b7d5d0c77869fe0.jpg";